module.exports = __webpack_public_path__ + "static/img/165.b9fd2b42.png";